import { render } from "./boilPlan.vue?vue&type=template&id=0305968d&scoped=true"
import script from "./boilPlan.vue?vue&type=script&lang=js"
export * from "./boilPlan.vue?vue&type=script&lang=js"

import "./boilPlan.vue?vue&type=style&index=0&id=0305968d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0305968d"

export default script